export const faqs = [
  {
    q: 'What is free?',
    a: 'The discovery call. We discuss your business workflow, assess whether it is suitable for an assistant pilot, and identify a sensible next step.',
  },
  {
    q: 'Does “Start for free” include a free assistant?',
    a: 'No. It starts the discovery process. The AI assistant pilot is a separate, paid engagement; its scope, fee, and any operating costs are confirmed in writing before you proceed.',
  },
  {
    q: 'Is this just a chatbot?',
    a: 'A conversation may be the interface, but the pilot is designed around a workflow. Depending on scope, the assistant may retrieve approved information, organize requests, prepare drafts, or route work for review.',
  },
  {
    q: 'Can it work with our existing tools?',
    a: 'We assess that during discovery. Any connections must be feasible and explicitly included in the agreed pilot scope.',
  },
  {
    q: 'What does our team need to provide?',
    a: 'A responsible point of contact, approved information, necessary access, and feedback during testing.',
  },
  {
    q: 'What happens after the pilot?',
    a: 'We review the findings and recommend whether to continue, revise, expand, or stop. Ongoing consulting is optional.',
  },
  {
    q: 'Can the assistant continue without a consulting retainer?',
    a: 'Continued operation is arranged separately from consulting. Hosting, software accounts, maintenance, and support responsibilities are defined before handoff.',
  },
  {
    q: 'What happens if the results are mixed?',
    a: 'The review should identify what worked, what did not, and what would need to change. A pilot is an evaluation—not a guarantee of a particular business outcome.',
  },
];
